import React from 'react';
import DesktopDevPageSide300x250Gak from './gak/DesktopDevPageSide300x250Atf';
const DesktopDevPageSide300x250Atf = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Gak, {
        safety: safety
    });
};
DesktopDevPageSide300x250Atf.displayName = 'DesktopDevPageSide300x250Atf';
export default DesktopDevPageSide300x250Atf;
